import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['error', 'button', 'coordsInput', 'accuracyInput', 'reverseInput', 'geocodeInput']

  initialize () {
    this.handleGeolocationSuccess = this.#handleGeolocationSuccess.bind(this)
    this.handleGeolocationError = this.#handleGeolocationError.bind(this)
  }

  startGeolocation () {
    if ('geolocation' in navigator) {
      this.buttonTarget.disabled = true
      this.errorTarget.classList.add('hidden')

      navigator.geolocation.getCurrentPosition(
        this.handleGeolocationSuccess,
        this.handleGeolocationError,
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      )
    } else {
      this.handleGeolocationError()
    }
  }

  #handleGeolocationSuccess (position) {
    if (this.hasAccuracyInputTarget) this.accuracyInputTarget.value = position.coords.accuracy
    this.#updateCoordinates({
      lat: position.coords.latitude,
      lng: position.coords.longitude
    })
  }

  #handleGeolocationError (error) {
    console.error(error)
    this.buttonTarget.disabled = false
    this.errorTarget.classList.remove('hidden')
  }

  #updateCoordinates (coords) {
    this.coordsInputTarget.value = `POINT(${coords.lng} ${coords.lat})`
    this.reverseInputTarget.value = 'true'
    this.geocodeInputTarget.value = 'true'

    this.element.requestSubmit()
  }
}
